module.exports = __webpack_public_path__ + "static/media/1.c5a7340c.png";